// extracted by mini-css-extract-plugin
export var logos = "D_X";
export var marquee = "D_Y";